import React from 'react';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function TransformationSection() {
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-pink/5 via-white to-kid-lime/5 relative overflow-hidden" data-id="element-416">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-417">
        <FadeIn data-id="element-418">
          <div className="text-center mb-8 md:mb-12" data-id="element-419">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-420">
              Imaginá este cambio en tu casa
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-pink to-kid-lime mx-auto rounded-full" data-id="element-421"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10" data-id="element-422">
          {/* ANTES */}
          <FadeIn direction="right" delay={0.1} data-id="element-423">
            <div className="bg-white border border-kid-rose/20 rounded-2xl p-5 md:p-8 shadow-sm h-full" data-id="element-424">
              <h3 className="text-xl font-bold text-kid-rose mb-6 text-center tracking-wider" data-id="element-425">
                ANTES
              </h3>
              <ul className="space-y-4" data-id="element-426">
                {['Frustración al intentar leer', 'Confusión con letras y sonidos', 'Tensión en cada tarea de lectura', 'Tu hijo evita practicar', 'Sensación de que "no puede"'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-427">
                    <XCircleIcon className="w-6 h-6 text-kid-rose flex-shrink-0 mt-0.5" data-id="element-428" />
                    <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-429">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* DESPUÉS */}
          <FadeIn direction="left" delay={0.2} data-id="element-430">
            <div className="bg-white border border-kid-lime/20 rounded-2xl p-5 md:p-8 shadow-sm h-full" data-id="element-431">
              <h3 className="text-xl font-bold text-kid-lime mb-6 text-center tracking-wider" data-id="element-432">
                DESPUÉS
              </h3>
              <ul className="space-y-4" data-id="element-433">
                {['Reconocimiento natural de sonidos', 'Mayor confianza al leer', 'Lectura progresiva sin presión', 'Aprendizaje como un juego', 'Tu hijo quiere seguir practicando'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-434">
                    <CheckCircle2Icon className="w-6 h-6 text-kid-lime flex-shrink-0 mt-0.5" data-id="element-435" />
                    <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-436">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-437">
          <p className="text-lg md:text-xl font-bold text-gray-900 text-center mt-6 md:mt-10" data-id="element-438">
            Todo esto con solo 10 minutos al día.
          </p>
        </FadeIn>
      </div>
    </section>;
}